import React from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { getFormattedDate } from '../../../../../global/helpers/date-helpers';
import { TcsmStates } from '../../../../../root/tcsm-model';
import { RelationshipsProps } from '../../../models/account-info-epi-props';
import { Dependent } from '../../dependents/dependents-model';
import { LabelSettingProps } from '../../../../../global/models/epi-model';
import { AccountInfoRoutes } from '../../../constants/routes';

interface ItemProps {
    domesticPartner: Dependent;
    canAddEdit: boolean;
    basePath?: string;
}


export function DomesticPartnerDisplay(props: ItemProps) {
    const { domesticPartner, canAddEdit, basePath } = props;

    const relationshipProps = useSelector<TcsmStates, RelationshipsProps>(state => state.epiProps?.relationshipsSettingState?.epiContent);
    const labelProps = useSelector<TcsmStates, LabelSettingProps>(state => state.epiProps?.labelSettingState?.epiContent);

   
    const View = () => {
        if (!domesticPartner) return null;

        return (
            <>
                <p>{`${domesticPartner.first_name} ${domesticPartner.person?.middle_name} ${domesticPartner.last_name} ${domesticPartner.person?.suffix}`}</p>
                <p className='grey-caption'>{`${relationshipProps.relationshipStartDateLabel || 'Relationship Start Date'}: ${getFormattedDate(domesticPartner?.start_date)}`}</p>
            </>
        );
    };

    const AddEdit = () => {
        if (!canAddEdit) return null;

        return (
            <Link to={`${basePath}${AccountInfoRoutes.DomesticPartner}`}>
                {labelProps?.editLabel}
            </Link>
        );
    };

    return (
        <>
            <View />
            <AddEdit />
        </>

    );
}

DomesticPartnerDisplay.defaultProps = {
    basePath: '',
};